import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { Card, Button, Row, Col, Modal, Form, Badge } from 'react-bootstrap';

const MesasLibres = ({ businessId, onRefresh, refetchTrigger }) => {
  const [mesasLibres, setMesasLibres] = useState([]);
  const [mesaSeleccionada, setMesaSeleccionada] = useState(null);
  const [comensalesTotal, setComensalesTotal] = useState(1);
  const [showAsignarModal, setShowAsignarModal] = useState(false);

  const mozo = JSON.parse(localStorage.getItem('user'));

  const fetchMesasLibres = async () => {
    try {
      const res = await api.get(`/mesas?business_id=${businessId}&status=libre`);
      setMesasLibres(res.data);
    } catch (err) {
      console.error('Error al traer mesas libres:', err);
    }
  };

  useEffect(() => {
    fetchMesasLibres();
  }, [businessId, refetchTrigger]);

  const asignarmeMesa = (mesa) => {
    setMesaSeleccionada(mesa);
    setComensalesTotal(1);
    setShowAsignarModal(true);
  };

  const confirmarAsignacion = async () => {
    try {
      await api.patch(`/mesas/${mesaSeleccionada.id}/asignar`, {
        mozo_id: mozo.id,
        comensales_total: comensalesTotal,
      });
      setShowAsignarModal(false);
      setMesaSeleccionada(null);
      onRefresh();
      fetchMesasLibres();
    } catch (err) {
      alert(err.response?.data?.message || 'No se pudo asignar la mesa');
    }
  };

  return (
    <>
{/*       <h4 className="mt-4">Mesas libres</h4> */}
      <Row>
        {mesasLibres.length === 0 ? (
          <Col>
            <p className="text-muted">No hay mesas disponibles en este momento.</p>
          </Col>
        ) : (
          mesasLibres.map((mesa) => (
            <Col xs={12} sm={6} md={4} lg={3} key={mesa.id} className="mb-3">
              <Card className="shadow-sm border-0 rounded-3">
                <Card.Body>
                  <Card.Title className="d-flex justify-content-between align-items-center">
                    <span className="fs-5 fw-semibold">Mesa {mesa.name}</span>
                    <Badge bg="success">Libre</Badge>
                  </Card.Title>

                  <Card.Text className="text-muted small">
                    👥 Capacidad: {mesa.comensales}
                  </Card.Text>

                  <div className="d-grid">
                    <Button variant="outline-success" size="sm" onClick={() => asignarmeMesa(mesa)}>
                      ✅ Asignarme
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))
        )}
      </Row>

      {/* Modal de asignación */}
      <Modal show={showAsignarModal} onHide={() => setShowAsignarModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Asignar mesa {mesaSeleccionada?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>
              Cantidad de comensales (máx: {mesaSeleccionada?.comensales})
            </Form.Label>
            <Form.Control
              type="number"
              min={1}
              max={mesaSeleccionada?.comensales}
              value={comensalesTotal}
              onChange={(e) => setComensalesTotal(parseInt(e.target.value))}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAsignarModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="success"
            onClick={confirmarAsignacion}
            disabled={
              comensalesTotal < 1 || comensalesTotal > mesaSeleccionada?.comensales
            }
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MesasLibres;
